/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import styled from 'styled-components/native'

export const ButtonContainerFlexStart = styled.View({
  alignSelf: 'flex-start',
})
